import { faker } from '@faker-js/faker';
import { useGetProjectInstallationsQuery } from 'generated/graphql';
import { DateTime } from 'luxon';
import React from 'react';

export interface IData {
  id: string;
  area: string;
  type: string;
  estimatedStartDate: DateTime;
  name: string;
  planId: string;
  status: string;
  numberOfActiveDecisions: number;
}

export function useQuery(projectId: string) {
  const tuple = useGetProjectInstallationsQuery({
    variables: {
      projectId: projectId
    },
    skip: projectId === ''
  });

  return React.useMemo(
    () => {

      const installations = tuple.data?.project?.installations;

      const data: IData[] = installations?.map((node) => ({
        id: node.id ?? '',
        area: `${node.area.displayName} ${node.subArea.displayName}`,
        type: node.installationType.displayName,
        estimatedStartDate: DateTime.fromISO(`${node.decisions[0]?.dueDate ?? `${node.estimatedStartDate}`}`),
        name: node.name ?? '',
        numberOfActiveDecisions: node.decisions.filter((node) => !node.approved).length ?? 0,
        planId: faker.string.alphanumeric({
          length: 6
        }),
        status: node.status.displayName
      })) ?? [];

      return {
        ...tuple,
        data
      };
    },
    [tuple]
  );
}
